import './leaderboard.css';
import { leaderboardStore } from '../../store/leaderboard.store.js';
import { authStore } from '../../store/auth.store.js';
import { createLeaderboardRow } from './LeaderboardRow.js';
import { createEditCreditsModal } from '../AdminPanel/AdminPanel.js';
import { removeMember } from '../../api/leaderboard.js';
import { showToast } from '../UI/Toast.js';
export function createLeaderboard() {
    const section = document.createElement('section');
    section.className = 'leaderboard-section';
    const render = () => {
        const { members, season, loading } = leaderboardStore.getState();
        section.innerHTML = `
      <div class="leaderboard-header">
        <div class="leaderboard-title-group">
          <div class="leaderboard-season">${season?.title ?? 'Loading...'}</div>
          <h1 class="leaderboard-heading">Leaderboard</h1>
          ${!loading
            ? `<div class="leaderboard-count">${members.length} member${members.length !== 1 ? 's' : ''}</div>`
            : ''}
        </div>
      </div>

      ${loading
            ? `
        <div class="leaderboard-skeleton">
          ${Array(5).fill('<div class="skeleton-row"></div>').join('')}
        </div>
      `
            : members.length === 0
                ? `
        <div class="leaderboard-empty">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="var(--color-border)" stroke-width="1.5">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          <p>No members yet this season</p>
        </div>
      `
                : `
        <div class="leaderboard-table" role="list">
          ${members.map((m) => `<div data-placeholder="${m.id}" role="listitem"></div>`).join('')}
        </div>
      `}
    `;
        if (!loading && members.length > 0) {
            const table = section.querySelector('.leaderboard-table');
            members.forEach((member, index) => {
                const placeholder = table.querySelector(`[data-placeholder="${member.id}"]`);
                const row = createLeaderboardRow(member, index + 1, {
                    onEdit: handleEdit,
                    onRemove: handleRemove,
                });
                placeholder.replaceWith(row);
            });
        }
    };
    const handleEdit = (member) => {
        const modal = createEditCreditsModal(member, () => render());
        modal.open();
    };
    const handleRemove = async (member) => {
        const confirmed = window.confirm(`Remove "${member.name}" from the leaderboard? This cannot be undone.`);
        if (!confirmed)
            return;
        try {
            await removeMember(member.id);
            leaderboardStore.removeMember(member.id);
            showToast({ message: `${member.name} removed`, type: 'success' });
        }
        catch (err) {
            showToast({ message: err.message ?? 'Failed to remove member', type: 'error' });
        }
    };
    // Initial render
    render();
    // Subscribe to store changes
    const unsubscribeLB = leaderboardStore.subscribe(render);
    const unsubscribeAuth = authStore.subscribe(render);
    // Cleanup on disconnect
    const observer = new MutationObserver(() => {
        if (!document.body.contains(section)) {
            unsubscribeLB();
            unsubscribeAuth();
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return section;
}
